import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Grid, Switch } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import customersSurveyLoop from '../../../../assets/img/customers-survey-loop.gif';
import { PLAN_TYPE } from '../../../../constants/Subscriptions';
import { Project } from '../../../../domain/project/Project';
import { useRetrieveOrganization } from '../../../../hooks/organization/useRetrieveOrganization';
import { useUpdateProject } from '../../../../hooks/project/useUpdateProject';
import ProjectCustomersMapper from '../../../../mappers/project/ProjectCustomersMapper';
import { Accordion } from '../../../../react-components/Accordion';
import Text from '../../../../react-components/Text';

interface CustomersSurveyProps {
  project: Project;
}

export const CustomersSurvey = ({ project }: CustomersSurveyProps) => {
  const { run: editProject } = useUpdateProject({ project });
  const { data: organization } = useRetrieveOrganization();

  const hasSubscriptionPermissions = () => {
    return organization?.subscription?.plan !== PLAN_TYPE.MONKEY;
  };

  const isEnabled = (): boolean => {
    return Boolean(project.customers.fields.find((field) => field.id === `survey`));
  };

  return (
    <div
      style={{
        border: `1px solid #E0E0E0`,
        borderRadius: `2px`,
      }}
    >
      <Accordion
        id="customers_app_pin"
        expanded
        headerStyles={{
          position: `relative`,
          paddingTop: `16px`,
        }}
        headerContent={
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            style={{ marginTop: `-8px` }}
          >
            <Text style={{ cursor: `pointer` }} variant="body-large" isBold intlId="customers.app.options.survey" />

            <span onClick={(event) => event.stopPropagation()}>
              <Switch
                checked={isEnabled()}
                value={isEnabled()}
                disabled={!hasSubscriptionPermissions()}
                onClick={(event) => event.stopPropagation()}
                onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                  const projectCustomers = ProjectCustomersMapper.toDTO(project.customers);

                  if (!checked) {
                    projectCustomers.fields = projectCustomers.fields.filter((field) => field.id !== `survey`);
                  } else {
                    projectCustomers.fields.push({
                      id: `survey`,
                      type: `survey`,
                    });
                  }

                  editProject({
                    customers: ProjectCustomersMapper.toDomain(projectCustomers),
                  });
                }}
                color="primary"
              />
            </span>
          </Grid>
        }
      >
        {!hasSubscriptionPermissions() ? (
          <Grid
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            style={{ backgroundColor: `#5073B5`, padding: `8px 16px` }}
          >
            <Grid item>
              <ArrowUpwardIcon style={{ fontSize: `20px`, color: RoutalPalette.neutral00 }} />
            </Grid>
            <Grid item>
              <Text
                style={{
                  fontSize: `12px`,
                  color: RoutalPalette.neutral00,
                  textAlign: `center`,
                }}
                intlId="customers.app.options.survey.upgrade"
              />
            </Grid>
          </Grid>
        ) : (
          <div
            style={{
              borderTop: `1px solid #E0E0E0`,
              padding: `16px`,
            }}
          >
            <Text variant="label" intlId="customers.app.options.survey.info" />
            <VSpacer small />

            <Grid
              container
              direction="row"
              style={{
                borderRadius: `2px`,
                border: `1px solid #E0E0E0`,
                padding: `8px`,
                margin: `0 16px`,
                width: `calc(100% - 32px)`,
              }}
              justifyContent="center"
            >
              <Grid item>
                <img style={{ width: `100%` }} src={customersSurveyLoop} alt="" draggable={false} />
              </Grid>
            </Grid>
          </div>
        )}
      </Accordion>
    </div>
  );
};
